import styled from 'styled-components'
import breakpoint from 'components/breakpoint'
import Button from './button'

const LoginPageButton = styled(Button)`
  margin-bottom: 20px;
  margin-right: 20px;
  flex-basis: calc(50% - 10px);
  flex-shrink: 0;
`

const Label = styled.p`
  margin: 0 0 20px 0;
  font-size: ${props => (props.big ? '18px' : '16px')};
  line-height: ${props => (props.big ? '24px' : '22px')};
`

const LogisterPageSeparator = styled.div`
  background-color: #d4d4d4;
  width: 1px;
  margin-left: 32px;

  ${breakpoint('landscape')`
    margin-left: 72px;
  `};
`

export {LoginPageButton, Label, LogisterPageSeparator}
